(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cf-home-spots')) {
    customElements.define('cf-home-spots', class extends HTMLElement {
      connectedCallback() {
        this.spots = [...this.querySelectorAll('.cf-hx__spot')];
        this.touch = matchMedia('(hover: none)');
        this.onClick = event => {
          const spot = event.target.closest('.cf-hx__spot');
          if (!spot || !this.touch.matches) return;
          // Touch: the first tap shows what the object needs, the second tap opens the collection.
          if (!spot.classList.contains('is-open')) {
            event.preventDefault();
            this.close();
            spot.classList.add('is-open');
          }
        };
        this.onOutside = event => { if (!this.contains(event.target)) this.close(); };
        this.onKey = event => { if (event.key === 'Escape') this.close(); };
        this.addEventListener('click', this.onClick);
        document.addEventListener('click', this.onOutside);
        document.addEventListener('keydown', this.onKey);
      }
      close() { this.spots.forEach(spot => spot.classList.remove('is-open')); }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('keydown', this.onKey);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-home-media-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cf-home-film')) {
    customElements.define('cf-home-film', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.userStarted = false;
        this.visible = false;
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.controls = false;
        this.button.hidden = false;
        this.onState = () => {
          const playing = !this.video.paused;
          const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
          this.button.querySelector('.cf-sr').textContent = label;
          this.button.setAttribute('aria-label', label);
          this.button.setAttribute('title', label);
          this.button.dataset.playing = String(playing);
          this.button.setAttribute('aria-pressed', String(playing));
        };
        this.onClick = () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.userStarted = true;
            this.video.play().catch(() => { this.video.controls = true; });
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        };
        this.onVisibility = () => this.sync();
        this.onReady = () => this.sync();
        this.onMotion = () => {
          if (this.motion.matches) this.userStarted = false;
          this.sync();
        };
        this.button.addEventListener('click', this.onClick);
        this.video.addEventListener('play', this.onState);
        this.video.addEventListener('pause', this.onState);
        this.video.addEventListener('canplay', this.onReady);
        this.motion.addEventListener('change', this.onMotion);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35;
          this.sync();
        }, { threshold: [0, .35] });
        this.observer.observe(this);
        // Fetch film data only when the film is about to scroll into view (never during page load).
        this.warm = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting) return;
          if (!this.motion.matches) this.video.preload = 'auto';
          this.warm.disconnect();
        }, { rootMargin: '400px 0px' });
        this.warm.observe(this);
        this.onState();
        this.sync();
      }
      sync() {
        if (!this.visible || document.hidden || this.userPaused || (this.motion.matches && !this.userStarted)) {
          this.video.pause();
        } else if (this.video.paused) {
          this.video.play().catch(() => {});
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.warm?.disconnect();
        this.video?.pause();
        this.button?.removeEventListener('click', this.onClick);
        this.video?.removeEventListener('play', this.onState);
        this.video?.removeEventListener('pause', this.onState);
        this.video?.removeEventListener('canplay', this.onReady);
        this.motion?.removeEventListener('change', this.onMotion);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-sn-features"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => {
    const roots = scope.matches?.('[data-snf-root]') ? [scope] : scope.querySelectorAll('[data-snf-root]');
    roots.forEach(root => {
      if (root.dataset.snfReady) return;
      const panels = [...root.querySelectorAll('[data-snf-panel]')];
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const points = [...root.querySelectorAll('.snf-point')];
      if (!panels.length) return;
      panels.forEach((panel, i) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs[i].id);
        panel.tabIndex = 0;
      });
      const select = index => {
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        points.forEach((point, i) => point.setAttribute('aria-pressed', String(i === index)));
      };
      root.querySelectorAll('[data-snf-select]').forEach(control => control.addEventListener('click', () => select(Number(control.dataset.snfSelect))));
      tabs.forEach((tab, index) => tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); select(next); tabs[next].focus();
      }));
      root.addEventListener('shopify:block:select', event => {
        const index = panels.findIndex(panel => panel.contains(event.target));
        if (index >= 0) select(index);
      });
      root.dataset.snfReady = 'true';
      root.querySelector('.snf-tabs').hidden = false;
      points.forEach(point => { point.hidden = false; });
      select(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-vs-features"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => {
    const roots = scope.matches?.('[data-vsf-root]') ? [scope] : scope.querySelectorAll('[data-vsf-root]');
    roots.forEach(root => {
      if (root.dataset.vsfReady) return;
      const panels = [...root.querySelectorAll('[data-vsf-panel]')];
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const points = [...root.querySelectorAll('.vsf-point')];
      if (!panels.length) return;
      panels.forEach((panel, i) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs[i].id);
        panel.tabIndex = 0;
      });
      const select = index => {
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        points.forEach((point, i) => point.setAttribute('aria-pressed', String(i === index)));
      };
      root.querySelectorAll('[data-vsf-select]').forEach(control => control.addEventListener('click', () => select(Number(control.dataset.vsfSelect))));
      tabs.forEach((tab, index) => tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); select(next); tabs[next].focus();
      }));
      root.addEventListener('shopify:block:select', event => {
        const index = panels.findIndex(panel => panel.contains(event.target));
        if (index >= 0) select(index);
      });
      root.dataset.vsfReady = 'true';
      root.querySelector('.vsf-tabs').hidden = false;
      points.forEach(point => { point.hidden = false; });
      select(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
